import * as _ from 'lodash';
import { Component, DestroyRef, ElementRef, HostListener, inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { PopoverService } from 'app/core/services/popover.service';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { selectAllBidders, selectCurrentAuction } from '../../features/auction.selectors';
import { loadAuction, saveCategory } from '../../features/auction.actions';
import { ModalAuctionDetailService } from '../../services/modal-auction-detail/modal-auction-detail.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastService } from 'app/toast/services/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-manage-aution-page-a',
  templateUrl: './manage-aution-page-a.component.html',
  styleUrls: ['./manage-aution-page-a.component.scss']
})
export class ManageAutionPageAComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public isDownloadHovered = false
  
  @ViewChild('manageAuctionPage', { static: true }) manageAuctionPageRef: ElementRef;

  @HostListener('document:click', ['$event'])
  onHidePopover(event: MouseEvent) {
    if (window && window.getSelection && window.getSelection().toString().length) {
      return;
    }

    const { list } = this.popoverService;
    for(let key in list) {
      const popover = list[key];
      popover.hide();
    }
  }

  @Input() id: string;

  public scheduleReminderClassList = {
    disabled: false
  }

  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  public scheduleReminderAllBiddersClassList = {
    disabled: false
  }


  constructor(
    public element: ElementRef,
    public store: Store,
    public sharedService: SharedService,
    public route: ActivatedRoute,
    public router: Router,
    public auctionManageService:AuctionManageService,
    private popoverService: PopoverService,
    private modalAuctionDetailService: ModalAuctionDetailService,
    private clipboard: Clipboard,
    private toastService: ToastService,
    private routeReuseStrategyService: RouteReuseStrategyService,
  ) { }

  public activeTab = 'auctions'

  public auctionStatus = 0
  public auctionType = 0
  public auction = null
  public allBidders = [];
  public isShowPauseCounter = false
  public isShowCloseCounter = false

  public items = []
  public filteredItems = []
  public filteredByCategory = []
  public noDeletedItems = []

  public customUserCategories = []
  public categories = {custom:{}}

  public isModalOpen: boolean = false;
  public itemSearch: UntypedFormControl = new UntypedFormControl('', []);
  public createdOn = '';
  public auctionLink: any = null;
  public auctionSlideShowLink: any = null;

  public search: UntypedFormControl = new UntypedFormControl('', []);

  public auction$: any = this.store.pipe(
    select(selectCurrentAuction),
    takeUntilDestroyed()
  )

  public allBiddersSelector$ = this.store.pipe(
    select(selectAllBidders),
    takeUntilDestroyed(),
  )

  ngOnInit(): void {
    const $ = window['$'];

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ future }) => {
      switch(future.fragment) {
        case "":
          $(`#auctionsTabbNav`).tab('show');
          break;
        default:
          $(`#${future.fragment}Nav`).tab('show');
      }
    });

    this.auctionManageService.category = 'All Items'
    
    this.store.dispatch({
      type:loadAuction.type,
      payload: this.id,
    })

    this.auction$.subscribe((auction)=>{
      this.auction = auction
      this.auctionManageService.auction = auction

      if(auction){
        this.auctionType = auction.campaignTypeData.auctionType
        this.getLinks(auction)
        this.getItemCategories(auction)

        this.store.dispatch({
          type:saveCategory.type,
          payload: this.categories,
        })
        
        window['$']('[data-toggle="tooltip-manage-status"]').tooltip();
        window['$']('[data-toggle="tooltip-reminder"]').tooltip();
        window['$']('[data-toggle="tooltip"]').tooltip()
        this.noDeletedItems = auction.campaignTypeData.presetOptions.filter(auctionItem => auctionItem.status !== 1)
        this.auctionManageService.items = [...this.noDeletedItems]
        this.auctionManageService.filterAuctionsItems()

        if (this.auction.campaignTypeData.auctionControlMethod === 1)
          this.isShowPauseCounter = true
        else 
          this.isShowPauseCounter = false

        if(this.auction.campaignTypeData.auctionCloseTime > 0 && this.auction.campaignTypeData.autoCloseEnabled === true)
          this.isShowCloseCounter = true
        else if(this.auction.campaignTypeData.autoCloseEnabled === false)
          this.isShowCloseCounter = false

        this.getAuctionCreationDate(this.auction.created)

        const { fragment } = this.route.snapshot
        switch(fragment) {
          case null:
          case "":
            this.setActiveTab("auctions");
            break;
          case "remindersTab":
            this.showRemindersPage();
          default:
            const activeTab = this.route.snapshot.fragment.slice(0, -3);
            this.setActiveTab(activeTab); 
        }
      }
    })

    this.itemSearch.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(itemSearch => {
      this.auctionManageService.searchQuery = itemSearch
      this.auctionManageService.filterAuctionsItems()
    })

    this.itemSearch.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(itemSearch => {
      this.auctionManageService.searchQuery = itemSearch
      this.auctionManageService.filterAuctionsItems()
    }); 

    this.allBiddersSelector$.subscribe(list => {
      this.allBidders = list;
      this.scheduleReminderAllBiddersClassList = {
        disabled: this.allBidders.length === 0
      }
    })

    window['$']('[data-toggle="tooltip"]').tooltip()
    window['$']('[data-toggle="tooltip-reminder"]').tooltip();
    window['$']('[data-toggle="tooltip"]').tooltip()
  }

  ngAfterViewInit(): void {
    const self = this;

    this.resetSearch()
    const campaignStyles = window['documentManager'].createElement('link');
    campaignStyles.href = 'paybee-spa/styles.css?v=398';
    campaignStyles.rel = 'stylesheet';
    window['$'](this.manageAuctionPageRef.nativeElement).append(campaignStyles);

    $('a[role="tab"]').off('shown.bs.tab');
    $('a[role="tab"]').on('shown.bs.tab', ({ target }) => {
      const tab = target.id.slice(0, -6);
      this.setActiveTab(tab);
    })

    $(this.element.nativeElement).off("click");
    $(this.element.nativeElement).on("click", "a[role='tab']", function(event) {
      event.preventDefault();

      const fragment = $(this).data('fragment');
      self.router.navigate([], { relativeTo: self.route, fragment });
    });
  }

  setActiveTab(tab) {
   this.activeTab = tab;
  }
  
  getAuctionStatusHTML(){
    return this.auctionManageService.getAuctionStatusHtml(this.auction)
  }

  getAuctionStatus(){
    let result = this.auctionManageService.getAuctionStatus(this.auction)
    this.auctionStatus = result.status

    const campaignTypeData = this.auction.campaignTypeData;
    if(this.auctionStatus == 2 || 
      campaignTypeData.autoCloseEnabled && campaignTypeData.auctionCloseTime < new Date().getTime() / 1000) {
      this.isShowPauseCounter = false;
      this.isShowCloseCounter = false;
    }

    this.auctionType = result.type

    this.scheduleReminderClassList = {
      disabled: result.status === 2
    }
    return result.status
  } 

  onStopClick(auction){

    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal--paybee-red-title modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          modalTitle: `Close "${auction.name}" Now`,
          text: `This Action is Irreversible.`,
          innerHtml:`
            This will result in following: <br>
              <div class="pl-2 pt-1">
                1. No more bids will be allowed <br>
                2. Winners will be notified with payment link.
              </div>`,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (result) => {
            if(result == false) {             
            }else{
              this.auctionManageService.onCloseAuction(auction).pipe(
                takeUntilDestroyed(this.destroyRef)
              ).subscribe((data:any)=>{
                if(Object.keys(data).includes('success')){
                  this.isShowPauseCounter = false
                  this.isShowCloseCounter = false
                  this.store.dispatch({
                    type:loadAuction.type,
                    payload: this.id,
                  })
                }
              })
            }
          }
        }
      }
    });
    this.store.dispatch(action);

  }

  onNotifyAuctionClosingClick(auction){
    window['orgMain'].notifyAuctionClosing(auction)
  }

  onNotifyAllBiddersClick(){
    window['orgMain'].showNotifyAllBiddersModal(this.auction)
  }

  onPauseResumeClick(auction){
    let titleText = ''
    if(auction.campaignTypeData.auctionStatus == 0){
      titleText = `Do you want to stop bidding now for this "${auction.name}" ?`
    }else{
      titleText = `Do you want to start bidding now for this "${auction.name}" ?`
    }

    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          modalTitle: "Change of auction status",
          text: titleText,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (result) => {
            if(result == false) {             
            }else{
              this.auctionManageService.setAuctionStatus(auction).pipe(
                takeUntilDestroyed(this.destroyRef)
              ).subscribe((data:any)=>{
                if(Object.keys(data).includes('success')){
                  this.isShowPauseCounter = false
                  this.store.dispatch({
                    type:loadAuction.type,
                    payload: this.id,
                  })
                }
              })
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  resetSearch() {
    this.itemSearch.setValue('');
  }

  openAuctionDetailModal() {
    let params = {
      campaignId : this.auction.id,
      presetId : 1,
      status: this.auctionManageService.getAuctionStatus(this.auction).status,
      auctionType: this.auctionType
    }

    const data = {
      params,
      placeOfCall: 'search'
    }

    const modalRef = this.modalAuctionDetailService.open(data);

    modalRef.onClose.pipe().subscribe(() =>{
      this.modalAuctionDetailService.modalRef = null;
    })
  }

  ngOnDestroy():void{
    const $ = window['$'];
    $("#manageAuctionPage").hide();
    $("#manageAuctionPage").empty();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();
  }

  getItemFilterCategories(auction){
    let categories = []
    auction.campaignTypeData.presetOptions
      .filter(auctionItem => auctionItem.status !== 1)
      .forEach(option => {
        categories = [...categories,...option.categories]
      });
    return _.uniq(categories)
  }

  getItemCategories(auction){
    let items = auction.campaignTypeData.presetOptions.filter(auctionItem => auctionItem.status !== 1)

    this.categories['allItems'] =  items.filter(auctionItem => auctionItem.status !== 1).length
    this.categories['noBidsItems'] = items.filter((item)=>{
      const currentBids = _.isNull(item.currentBids)?[]:item.currentBids;
      if(currentBids.length < 1 ){
        return item
      }
    }).length
    this.categories['pendingItems'] = _.filter(items, (item: any) => {
      const soldItems = _.isNull(item.soldItems)?[]:item.soldItems;
      let pendingItem = soldItems.find(soldItem=>soldItem.status == 1)
        if(pendingItem){
           return item
        }
    }).length
    this.categories['paidItems'] = _.filter(items, (item: any) => {
      const soldItems = _.isNull(item.soldItems)?[]:item.soldItems;
      let paidItem = soldItems.find(soldItem=>soldItem.status == 0)
        if(paidItem){
           return item
        }
    }).length
    this.categories['unsoldItems'] = items.filter(opt=>(opt.soldCount < opt.count)).length;
    this.categories['soldOutItems'] = items.filter(opt=>(opt.soldCount == opt.count)).length;
    this.categories['noActivityItems'] = items.filter(opt=>(opt.soldCount == 0 && !opt.currentBids && !opt.currentAutoBids )).length;
    this.categories.custom = {}
    items.forEach(item => {
      const categories = _.isNull(item.categories)?[]:item.categories;
      if(categories.length > 0){
        categories.forEach(category=>{
          if(Object.keys(this.categories.custom).includes(category)){
            this.categories.custom[category] += 1
          }else{
            this.categories.custom[category] = 1
          }
        })
      }
    });
  }

  showRemindersPage() {
    const { scheduler, SchedulerTaskType, $ }: any = window;
    scheduler.reset();

    scheduler.data = this.auction
    scheduler.campaignId = this.id;

    scheduler.updateEventDateTime();

    const taskTypeList = [
        SchedulerTaskType.SilentAuctionClosing,
        SchedulerTaskType.ScheduleTaskCustomAuctionReminder,
    ];

    let cancelledList = [];
    let scheduledList = [];
    let completedList = [];
    var sortRemindersByStatus = function(reminders) {
        for (let i = 0; i < reminders.length; i++) {
            if(reminders[i].status === 0) 
                scheduledList.push(reminders[i])
            if(reminders[i].status === 2 || reminders[i].status === 3)
                completedList.push(reminders[i])
            if(reminders[i].status === 4)
                cancelledList.push(reminders[i])
        }
    }

    return scheduler.getMultipleTaskListByCampaign(scheduler.data, taskTypeList).then(() => {
      sortRemindersByStatus(scheduler.list);

      if(scheduledList.length < 1) {
          $(`*[data-section="scheduledReminderCard"]`).hide();
      } else {
          $(`*[data-section="scheduledReminderCard"]`).show();
          const listHTML = scheduler.getScheduledTaskListHTML(scheduledList);
          $(`*[data-section="scheduledReminderListContainer"]`).html(listHTML);
      }

      if(completedList.length < 1) {
          $(`*[data-section="completedReminderCard"]`).hide();
      } else {
          $(`*[data-section="completedReminderCard"]`).show();
          const listHTML = scheduler.getScheduledTaskListHTML(completedList);
          $(`*[data-section="completedReminderListContainer"]`).html(listHTML);
      }

      if(cancelledList.length < 1) {
          $(`*[data-section="cancelledReminderCard"]`).hide();
      } else {
          $(`*[data-section="cancelledReminderCard"]`).show();
          const listHTML = scheduler.getScheduledTaskListHTML(cancelledList);
          $(`*[data-section="cancelledReminderListContainer"]`).html(listHTML);
      }
        
      return null;
    }).then(() => {
        const timestamp = scheduler.data.campaignTypeData.startDateTimeGmtUnix || 0;
        scheduler.timestamp[SchedulerTaskType.SilentAuctionClosing] = timestamp;
        scheduler.timestamp[SchedulerTaskType.CloseAuction] = timestamp;
 
        scheduler.updateReminders();
        return scheduler.init(() => {
            this.showRemindersPage();

            if($("#scheduledReminderHeadingLink").hasClass("collapsed")) {
              $("#scheduledReminderHeadingLink").click();
          }
        });
    })
  }

  navigateByUrl(url: string) {
    return this.router.navigateByUrl(url);
  }
  
  getAuctionCreationDate(created) {
    const unixTimestamp = created;
    const date = new Date(unixTimestamp * 1000);

    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate();

    this.createdOn = `${month} ${day}, ${year}`;
  }

  getLinks(auction) {
    const handle = _.get(window['localOrgData'], 'user.handle', 'handle');
    const intid = _.get(auction, 'intid', 0);
    const protocol = window.location.protocol;
    const hostName = window.location.hostname

    this.auctionLink = protocol + "//" + hostName + "/@" + handle + "@" + intid;
    this.auctionSlideShowLink = protocol + "//" + hostName + '/auction_show/handle/' + handle + '/ppid/' + intid;
  }

  copyLink(url) {
    try {
      this.clipboard.copy(url);
      this.toastService.show('success', 'URL copied to clipboard', {delay: 1500});
    } catch (error) {
      this.toastService.show('danger', 'Error copying URL to clipboard', {delay: 1500});
    }
  }
}
